import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material"; 
import React from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Accordian from "../../../components/Accordian";
const Div = styled.div`
  display: flex;
  justify-content: space-between;

  align-items: center;
`;
const GridHEading = styled(Grid)`
  display: flex;
  align-items: center;

  place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const MovingImg = styled.div`
  animation: 3s infinite alternate-reverse floating;
  @-webkit-keyframes floating {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-15px);
    }
    100% {
      transform: translatey(15px);
    }
  }
`;
const TokeImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 500px;
  @media screen and (max-width:900px){
    margin: 20px 0px;
  }
`;
const index = () => {
  return (
    <div>
      <SectionWrapper p599="8rem 0px" p="15rem 0 12rem 0" p1050="15rem 0 0" p900="8rem 0 0" id="tokenomics">
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <GridHEading
              item
              xs={12}
              md={6}
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-offset="0"
              data-aos-duration="700"
            >
              <SectionHeading>Tokenomics</SectionHeading>
            </GridHEading>
            <Grid xs={12} md={6} item>
              <Grid container>
                <GridHEading xs={12} md={6}>
                  <SectionHeading
                  fs="28px"
                  fs1199="25px"
                    p="20px 0"
                    align="left"
                    maxWidth="100%"
                    data-aos="fade-zoom-in"
                    data-aos-easing="ease-in"
                    // data-aos-delay="500"
                    // data-aos-offset="0"
                    data-aos-duration="1200"
                  >
                    -No team tokens
                    <br /> -No dev tokens
                  </SectionHeading>
                </GridHEading>
                <GridHEading
                  pc="center"
                  xs={12}
                  md={6}
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  // data-aos-delay="500"
                  // data-aos-offset="0"
                  data-aos-duration="1500"
                >
                  <MovingImg>
                    <TokeImage
                      src="/images/apelogo.png" 
                    />
                  </MovingImg>
                </GridHEading>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Accordian />
      </SectionWrapper>
    </div>
  );
};

export default index;
